import useClientMutation from '../../common/useClientMutation';
import { ALERTS_REGISTERED_URL } from '../../consts';
export default function useUserAlertsRegistration(props) {
    return useClientMutation({
        cacheKey: 'userAlertsRegistration',
        url: ALERTS_REGISTERED_URL,
        fetchOptions: {
            method: 'GET'
        },
        clientOptions: {
            throwOnError: false,
            gcTime: 0,
            retry: false,
            onSuccess: props?.onSuccess,
            onError: props?.onError
        }
    });
}

//# sourceMappingURL=useUserAlertsRegistration.js.map